/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
} from './Organization';

/**
 * 
 * @export
 * @interface OrganizationDetails
 */
export interface OrganizationDetails {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    org_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    tenant_name: string;
    /**
     * 
     * @type {Array<Organization>}
     * @memberof OrganizationDetails
     */
    managed_organizations?: Array<Organization>;
}

/**
 * Check if a given object implements the OrganizationDetails interface.
 */
export function instanceOfOrganizationDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "org_name" in value;
    isInstance = isInstance && "tenant_name" in value;

    return isInstance;
}

export function OrganizationDetailsFromJSON(json: any): OrganizationDetails {
    return OrganizationDetailsFromJSONTyped(json, false);
}

export function OrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'org_name': json['org_name'],
        'tenant_name': json['tenant_name'],
        'managed_organizations': !exists(json, 'managed_organizations') ? undefined : ((json['managed_organizations'] as Array<any>).map(OrganizationFromJSON)),
    };
}

export function OrganizationDetailsToJSON(value?: OrganizationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parent_id': value.parent_id,
        'org_name': value.org_name,
        'tenant_name': value.tenant_name,
        'managed_organizations': value.managed_organizations === undefined ? undefined : ((value.managed_organizations as Array<any>).map(OrganizationToJSON)),
    };
}

